/**
 * Available predefined element types
 */
export type ElementType = 'opt-in' | 'opt-out' | 'settings';

/**
 * Style customization options
 */
export interface StyleCustomization {
  /** Text color in hex format */
  textColor?: string;
  /** Background color in hex format */
  backgroundColor?: string;
  /** Border radius in pixels */
  radius?: number;
  /** Width in pixels (within allowed range) */
  width?: number;
  /** Height in pixels (within allowed range) */
  height?: number;
}

/**
 * Configuration options for element injection
 */
export interface ElementConfig {
  /** The type of element to inject */
  type: ElementType;
  /** Style customization */
  styles?: StyleCustomization;
}

/**
 * Size constraints for different attributes
 */
export const SIZE_CONSTRAINTS = {
  width: { min: 50, max: 300 },
  height: { min: 20, max: 200 },
  radius: { min: 0, max: 50 }
} as const;

/**
 * Default styles for each element type
 */
export const DEFAULT_STYLES: Record<ElementType, StyleCustomization> = {
  'opt-in': {
    textColor: '#FFFFFF',
    backgroundColor: '#635bff',
    radius: 6,
    width: 200,
    height: 40
  },
  'opt-out': {
    textColor: '#333333',
    backgroundColor: '#e4e6eb',
    radius: 6,
    width: 200,
    height: 40
  },
  'settings': {
    textColor: '#333333',
    backgroundColor: '#e4e6eb',
    radius: 6,
    width: 200,
    height: 40
  }
} as const;

/**
 * Result of element injection
 */
export interface InjectionResult {
  /** Whether injection was successful */
  success: boolean;
  /** The injected iframe element (if successful) */
  iframe?: HTMLIFrameElement;
  /** Error message (if unsuccessful) */
  error?: string;
}

/**
 * Default configuration for the modal
 */
export const DEFAULT_MODAL_CONFIG = {
  title: "Support with Mellowtel",
  body: "Support your favorite developer with Mellowtel while you browse, turning your everyday browsing into real support for developers.",
}